import axiosClient from './axiosClient';

const API_PATH = '/user';

class UserApi {
  async getUser() {
    return axiosClient.get(`${API_PATH}`);
  }

  async register(user) {
    return axiosClient.post(`${API_PATH}/register`, user);
  }

  async login(user) {
    return axiosClient.post(`${API_PATH}/login`, user);
  }

  async updateUser(name, password) {
    return axiosClient.patch(`${API_PATH}`, { name, password });
  }

  async changePassword(data) {
    return axiosClient.patch(`${API_PATH}/password`, data);
  }

  async requestPasswordReset(email) {
    return axiosClient.post(`/password/request`, { email });
  }

  async resetPassword(user_id, token, password) {
    return axiosClient.post(`/password/reset`, {
      user_id,
      token,
      password,
    });
  }
}

const userApiInstance = new UserApi();
export default userApiInstance;
